<template>
    <IFrameDataLoader
        :id="$route.query.id"
        :token="$route.query.token"
        :message-source-random-id="$route.query.randomId"
        @index="setIndexMeta" />
</template>

<script>

export default {
    name: "EventIFrame",
    head() {
        return {
            meta: [
                {hid: 'robots', name: 'robots', content: this.indexMeta}
            ]
        }
    },
    data() {
        return {
            indexMeta: 'index'
        }
    },
    methods: {
        setIndexMeta(indexMeta) {
            this.indexMeta = indexMeta ? 'index' : 'noindex'
        }
    }
}
</script>

<style scoped>

</style>
